/**
 * Configuration de la page d'accueil DIGO.
 *
 * - digoLandingPageData : structure de sections au format PageBuilder.
 *   Utilisé quand aucune page n'est configurée dans le Console Sharetribe.
 *   Dès qu'une page "landing-page" est publiée dans le Console, elle prend
 *   automatiquement le dessus (voir LandingPage.js).
 *
 * - digoSectionComponents : registre des composants custom à injecter dans
 *   le PageBuilder via l'option `sectionComponents`.
 */

import SectionHeroDigo from './sections/SectionHeroDigo';
import SectionCategoriesDigo from './sections/SectionCategoriesDigo';
import SectionHowItWorksDigo from './sections/SectionHowItWorksDigo';
import SectionTrustDigo from './sections/SectionTrustDigo';
import SectionRecruitDigo from './sections/SectionRecruitDigo';
import SectionBrowseServicesDigo from './sections/SectionBrowseServicesDigo';
import SectionBrowseWorkersDigo from './sections/SectionBrowseWorkersDigo';

const GUEST_SECTIONS = [
  { sectionType: 'digoHero', sectionId: 'digo-hero' },
  { sectionType: 'digoHowItWorks', sectionId: 'digo-how-it-works' },
  { sectionType: 'digoCategories', sectionId: 'digo-categories' },
  { sectionType: 'digoTrust', sectionId: 'digo-trust' },
  { sectionType: 'digoRecruit', sectionId: 'digo-recruit' },
];

const LOGGED_IN_HERO_SECTION = { sectionType: 'digoHero', sectionId: 'digo-hero' };

export const digoLandingPageData = {
  sections: GUEST_SECTIONS,
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'DIGO : Humains à tout faire',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content:
        'Délègue tes tâches du quotidien à des travailleurs vérifiés. Déneigement, montage, aide ménagère et plus, partout au Québec.',
    },
  },
};

export const digoSectionComponents = {
  digoHero: { component: SectionHeroDigo },
  digoCategories: { component: SectionCategoriesDigo },
  digoHowItWorks: { component: SectionHowItWorksDigo },
  digoTrust: { component: SectionTrustDigo },
  digoRecruit: { component: SectionRecruitDigo },
  digoBrowseServices: { component: SectionBrowseServicesDigo },
  digoBrowseWorkers: { component: SectionBrowseWorkersDigo },
};

/**
 * Sections shown on the homepage depend on auth:
 * - Guest: full marketing landing
 * - Logged-in (client or worker): hero + browse-services grid
 *
 * @param {Object} params
 * @param {boolean} params.isAuthenticated
 * @param {Object} [params.currentUser]
 * @returns {Object} page asset data for PageBuilder
 */
export const getDigoLandingPageData = ({ isAuthenticated } = {}) => {
  if (!isAuthenticated) {
    return digoLandingPageData;
  }

  // Logged-in home is the hero only. The category grid now lives on its own
  // intermediary page (BrowseWorkersPage), reached from the hero's
  // "Trouver quelqu'un" button — so it is no longer mirrored on the home.
  return {
    ...digoLandingPageData,
    sections: [LOGGED_IN_HERO_SECTION],
  };
};
